import Vue from 'vue';
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import VueTippy, { TippyComponent } from 'vue-tippy';
import VueRouter from 'vue-router';
import { CardPlugin, LayoutPlugin, ModalPlugin } from 'bootstrap-vue';
import VueObserveVisibility from 'vue-observe-visibility';
import * as Sentry from '@sentry/vue';
import * as NProgress from 'nprogress';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        Vue,
        release: 'portal@' + process.env.PORTAL_VERSION,
        dsn: process.env.VUE_APP_SENTRY_URL,
        integrations: [new Sentry.BrowserTracing()],
        tracesSampleRate: 1.0,
    });
}

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(LayoutPlugin);
Vue.use(CardPlugin);
Vue.use(ModalPlugin);
Vue.use(VueObserveVisibility);
Vue.use(VueTippy, {
    theme: 'ims',
});
Vue.component('tippy', TippyComponent);

NProgress.configure({ showSpinner: false, trickleSpeed: 100, speed: 100 });

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app');
